import { getProvinceFeatureTerritory } from './territories';

const edgeKey = (start, end) => {
  const a = start.join(',');
  const b = end.join(',');
  return a < b ? `${a}|${b}` : `${b}|${a}`;
};

// The territorial layers share identical edges between adjacent divisions.
// Remove those edges per country to retain only national outlines and islands.
export const buildNeighborCountryOutlines = (geoJson) => {
  const countries = new Map();
  (geoJson?.features || []).forEach((feature) => {
    const country = getProvinceFeatureTerritory(feature)?.pais_codigo;
    if (!country || country === 'ARG') return;
    const geometry = feature.geometry;
    const polygons = geometry?.type === 'Polygon' ? [geometry.coordinates]
      : geometry?.type === 'MultiPolygon' ? geometry.coordinates : [];
    const rings = countries.get(country) || [];
    rings.push(...polygons.flat());
    countries.set(country, rings);
  });

  return {
    type: 'FeatureCollection',
    features: Array.from(countries, ([country, rings]) => {
      const counts = new Map();
      rings.forEach((ring) => {
        for (let index = 1; index < ring.length; index += 1) {
          const key = edgeKey(ring[index - 1], ring[index]);
          counts.set(key, (counts.get(key) || 0) + 1);
        }
      });
      const lines = [];
      rings.forEach((ring) => {
        let line = [];
        for (let index = 1; index < ring.length; index += 1) {
          const start = ring[index - 1];
          const end = ring[index];
          if (counts.get(edgeKey(start, end)) === 1) {
            if (line.length === 0) line.push(start);
            line.push(end);
          } else if (line.length > 0) {
            lines.push(line);
            line = [];
          }
        }
        if (line.length > 0) lines.push(line);
      });
      return {
        type: 'Feature',
        properties: { pais_codigo: country },
        geometry: { type: 'MultiLineString', coordinates: lines },
      };
    }),
  };
};
